import { Helmet } from 'react-helmet';
import type { Product } from '../../bff-api/products/model';

export const OrganizationSchema = ({ product }: { product?: Product }) => {
    if (product) {
        const { c_organizationSchema } = product;

        if (c_organizationSchema) {
            return (
                <Helmet>
                    <script type="application/ld+json">
                        {JSON.stringify(c_organizationSchema, null, 2)}
                    </script>
                </Helmet>
            );
        }
    }

    return null;
};
